import { defineComponent, ref, watch } from 'vue';

export const LogoComponent = defineComponent({
  name: 'LogoComponent',
  props: {
    logoUrl: {
      type: String,
    },
  },
  setup(props, { slots }) {
    const url = ref('');
    const loaded = ref(false);

    function reset() {
      url.value = undefined;
    }

    function onLoad() {
      loaded.value = true;
    }

    watch(() => props.logoUrl, () => {
      reset();
      if (!props.logoUrl) {
        return;
      }
      url.value = props.logoUrl;
    }, { immediate: true });


    return () => {
      if (slots.default && url.value)
        return slots.default({ url: url.value, reset, loaded: loaded.value, onLoad });
    }
  },
});